import { DevelopmentView } from '../views';
export default DevelopmentView;
